var UiComponentsDataTestIdEnum = /* @__PURE__ */ ((UiComponentsDataTestIdEnum2) => {
  UiComponentsDataTestIdEnum2["ACCORDION_SSR_ICON"] = "accordion-ssr-icon";
  UiComponentsDataTestIdEnum2["PROGRESSIVE_MODAL"] = "progressive-modal";
  UiComponentsDataTestIdEnum2["PILL_CONTAINER"] = "pill-container";
  UiComponentsDataTestIdEnum2["PILL_START_ICON"] = "pill-start-icon";
  UiComponentsDataTestIdEnum2["PILL_LABEL"] = "pill-label";
  UiComponentsDataTestIdEnum2["PILL_DESCRIPTION"] = "pill-description";
  UiComponentsDataTestIdEnum2["PILL_CLOSE"] = "pill-close";
  UiComponentsDataTestIdEnum2["DECORATIVE_PILL_CONTAINER"] = "decorative-pill-container";
  UiComponentsDataTestIdEnum2["DECORATIVE_PILL_START_ICON"] = "decorative-pill-start-icon";
  UiComponentsDataTestIdEnum2["DECORATIVE_PILL_LABEL"] = "decorative-pill-label";
  UiComponentsDataTestIdEnum2["DECORATIVE_PILL_DESCRIPTION"] = "decorative-pill-description";
  return UiComponentsDataTestIdEnum2;
})(UiComponentsDataTestIdEnum || {});
export {
  UiComponentsDataTestIdEnum
};
